module.exports = __webpack_public_path__ + "img/icon-chart.b5cacaca.svg";